import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { ApiService } from '../../../shared/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-show-message',
  templateUrl: './show-message.component.html',
  styleUrls: ['./show-message.component.scss']
})
export class ShowMessageComponent implements OnInit {
  @Input() id: number;
  message:any = {};
  piece_jointe:any = [];
  constructor(protected dialogRef: NbDialogRef<ShowMessageComponent>,private apiService:ApiService, private router:Router, public toastr: NbToastrService) {
  
  }

  ngOnInit() {
    this.getOneMessage();
  }

  cancel(){
    this.dialogRef.close();

    
  }

  close(){
    this.dialogRef.close();
    
    
  }

  getOneMessage(){
    this.apiService.getOneMessageProvider(this.id).subscribe(data =>{
      this.message = data;
     this.piece_jointe = this.message.pieces_jointes;
     
    },(err) =>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
    })
  }

}
